import React, { useState, useEffect } from "react";
import {
  getSignedDownloadUrl,
  DownloadFile,
} from "../../../../utils/downloadFile";

const BrochureContent = ({ attachment }) => {
  const [fileUrl, setFileUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [signedUrl, setSignedUrl] = useState("");

  useEffect(() => {
    console.log(attachment, "attachment in brochure mdoal");
    const fetchSignedUrl = async () => {
      if (!attachment?.blob_url) {
        setFileUrl("");
        setSignedUrl("");
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        const url = await getSignedDownloadUrl(attachment.blob_url);
        if (url) {
          setSignedUrl(url); // For download
          const fileType = attachment.file_name
            ?.split(".")
            .pop()
            ?.toLowerCase();
          // If it's an image, we can display it directly
          if (["png", "jpg", "jpeg", "gif"].includes(fileType)) {
            setFileUrl(url);
          } else {
            // PDFs: we cannot preview easily without react-pdf, so leave blank
            setFileUrl("");
          }
        } else {
          setFileUrl("");
          setSignedUrl("");
        }
      } catch (error) {
        console.error("Error fetching signed URL:", error);
        setFileUrl("");
        setSignedUrl("");
      } finally {
        setLoading(false);
      }
    };

    fetchSignedUrl();
  }, [attachment]);

  const handleDownload = async () => {
    if (!attachment?.blob_url) return;
    await DownloadFile(attachment.blob_url, null, attachment.file_name);
  };

  if (loading) return <p>Loading brochure...</p>;
  if (!signedUrl) return <p>Unable to load brochure</p>;

  const fileType = attachment.file_name?.split(".").pop()?.toLowerCase();

  return (
    <div className="d-flex flex-column align-items-center">
      {["png", "jpg", "jpeg", "gif"].includes(fileType) && fileUrl ? (
        <img
          src={fileUrl}
          alt="Brochure"
          style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
        />
      ) : fileType === "pdf" ? (
        <div className="p-5 text-center">
          Unable to preview PDF. Please download to view.
        </div>
      ) : (
        <div className="p-5 text-center">File preview not supported</div>
      )}

      <button className="btn btn-primary mt-3" onClick={handleDownload}>
        Download Brochure
      </button>
    </div>
  );
};

export default BrochureContent;
